function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Logo");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M32.85.54h2L45.29,24.69,55.81.54h2L46.28,26.86,61.71,62.17,88.76,0h2l-28,64.44h-2L45.38,29.13,30,64.44H28L0,0H2L29,62.17,44.38,26.86Z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M19,17.28h1.71V4.63H19V3.28h4.83V4.63H22.09V17.28h1.77v1.29H19Z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M60.19,17.28H62V4.63H60.19V3.28h2.45l11,12.41.42.57-.07-.7V4.63H72.4V3.28h4.83V4.63H75.37V19.27L63.73,6.36l-.39-.55,0,.68V17.28H65v1.29H60.19Z"
});

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 90.75 64.44",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Logo.ba20fc8f.svg";
export { ForwardRef as ReactComponent };